import template from 'product-shipping-returns.j2';
import { generate } from '../../../core/js/utils/componentUtils';

import { mDom } from '../../../core/js/utils/renderUtils';

import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

import {
    default as accordionSupport,
    useDefaultPDPTabSetStates
} from '../../../core/js/uiSupport/accordion';

function afterRender(store) {
    accordionSupport(this, this.templateLocation, useDefaultPDPTabSetStates);
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-shipping-returns-details',
        afterRender: afterRender,
        watch: ['product.selectedSku.sku'],
        accordionNameDataAttr: 'data-accordion-tab-name',
        accordionState: {},
        jsAccordionClass: '.js-accordion-tabset',
        template: template,
        name: 'productShippingDetailsComponent',
        renderType: mDom
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
